
define('jst!address_book_export/_empty',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="empty-list"><%=message%></div>');
 });

